const AvoidType = Object.freeze({
  HIGHWAYS: "HIGHWAYS",
  TOLLS: "TOLLS",
  FERRIES: "FERRIES",
  BORDERS: "BORDERS",
  INDOORS: "INDOORS"
});
export default AvoidType;